import styled from 'styled-components'

import { ColumnItem } from '../common'
import { Text } from '../../components/text'

import Palette from '../../assets/gui/1f3a8.png'
import Thinking from '../../assets/gui/1f914.png'

interface EmptyPageProps {
  emptyIcon?: 'palette' | 'thinking'
  content?: string
}

export const EmptyPage: React.FC<EmptyPageProps> = ({ emptyIcon, content }) => {
  const EmptyIcon = () => {
    switch (emptyIcon) {
      case 'palette':
        return <img src={Palette} alt="palette" />
      case 'thinking':
        return <img src={Thinking} alt="thinking" />
      default:
        return <></>
    }
  }

  return (
    <EmptyBox>
      <EmptyIcon />
      <Text size={14} lineHeight={22} color="text_secondary" $textAlign="center">
        {content}
      </Text>
    </EmptyBox>
  )
}

export type { EmptyPageProps }

const EmptyBox = styled(ColumnItem)`
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 100%;
  > img {
    width: 34px;
  }
`
